import React, { Component } from 'react';
import './ServicesCard.css';


export default function ServicesCard(props){
    
    return(
        <div className='service-card'>
            <img alt='illustration' src={props.image}></img>
            <h1>{props.heading}</h1>
            <p>
            {props.body}
            </p>
        </div>
    )
}